export default [
  // 班级管理
  {

    path: '/groupback/:groupID',
    component: () => import('@/views/pages/groupBack/index.vue'),
    redirect: '/groupback/:groupID/member',
    children: [
      // {
      //   path: 'setting',
      //   name: 'setting',
      //   meta: { title: "班级管理" },
      //   component: () => import('@/views/pages/groupBack/setting')
      // },


      {
        path: 'member',
        name: 'member',
        meta: { title: "成员管理" },
        component: () => import('@/views/pages/groupBack/member/index.vue')
      },
      {
        path: 'course',
        name: 'course',
        meta: { title: "课程管理" },
        component: () => import('@/views/pages/groupBack/course/index.vue')
      },
      {
        path: 'contest',
        name: 'contest',
        meta: { title: "比赛管理" },
        component: () => import('@/views/pages/groupBack/contest/index.vue')
      },
    ]
  }
]
